export default __webpack_public_path__ + "static/media/office-map.0342f5db.svg";